import { CARD, LINE } from './base';
import type { GlyphProps, PackArt } from './types';

/* Dema: lo que un bandito guarda en Trinchera, los obispos que lo manchan y lo que lo tapa. */

/**
 * Clancy: la mascara. La banda va a la altura de los ojos y no en la barbilla,
 * porque cualquier mancha oscura en la parte baja de una cara se lee como una
 * boca y la mascara salia sonriendo. Los ojos son huecos de la propia banda.
 */
function ClancyGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path
        d="M12 8h24c1.6 0 2.7 1.1 2.7 2.7 0 11-3.7 19.8-10 24.8-2.8 2.2-6.6 2.2-9.4 0-6.3-5-10-13.8-10-24.8C9.3 9.1 10.4 8 12 8z"
        fill="currentColor"
        fillOpacity="0.16"
      />
      <path
        fillRule="evenodd"
        d="M9.4 14h29.2v10.5H9.4zM14.2 19.2a3.9 2.7 0 1 1 7.8 0 3.9 2.7 0 1 1-7.8 0zM26 19.2a3.9 2.7 0 1 1 7.8 0 3.9 2.7 0 1 1-7.8 0z"
        fill="currentColor"
        fillOpacity="0.62"
        stroke="none"
      />
      <path d="M19.5 30h9" />
      <path d="M9.3 12H5M38.7 12H43" />
    </svg>
  );
}

/** Torchbearer: quien lleva la antorcha, con la cinta cruzada al pecho. */
function TorchbearerGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M36 4c4 4 6 7.2 6 9.8a6 6 0 0 1-12 0C30 11.2 32 8 36 4z" fill="currentColor" fillOpacity="0.35" />
      <path d="M32 19h8l-1.8 4h-4.4z" fill="currentColor" fillOpacity="0.2" />
      <path d="M30.5 19h11" />
      <path d="M36 23v9" strokeWidth={2.8} />
      <circle cx="16" cy="16" r="6.5" fill="currentColor" fillOpacity="0.18" />
      <path d="M5 44v-9c0-6.1 4.9-11 11-11s11 4.9 11 11v9z" fill="currentColor" fillOpacity="0.16" />
      <path d="M25.5 30l9 2" />
      <path d="M8 40l16-6" strokeWidth={3.4} />
    </svg>
  );
}

/**
 * Trash el dragon, de perfil. Cuello y morro largos en vez de cabezon: con la
 * cabeza redonda y dos cuernos finos parecia un insecto.
 */
function TrashGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M8 36c-3.5 2.5-5 5.5-5.5 8.5" strokeWidth={2.6} />
      <path d="M1.5 45.5l.8-6.2 5.2 2.6z" fill="currentColor" fillOpacity="0.3" />
      <path d="M17 27C12.5 18.5 13.5 10 20 4.5c.5 6.5 2.8 11.8 6.5 15.5-3.5.5-6.7 2.8-9.5 7z" fill="currentColor" fillOpacity="0.3" />
      <path d="M19.5 23C17.5 16.5 18 11.5 20.5 7M23 21.5C21.5 16 21.5 12 22 9" strokeWidth={1.3} />
      <ellipse cx="17" cy="34" rx="11" ry="8" fill="currentColor" fillOpacity="0.18" />
      <path d="M13 41.5v4M22 41.5v4" />
      <path d="M24.5 29.5c1.5-4.5 4-7.5 7.5-9.5" strokeWidth={6} />
      <path d="M31 14c2.5-2.5 5.5-3.2 8.5-2l6.5 5-7.5 2.5c-1.5 1.8-4 2.5-6.2 1.4-2.8-1.4-3.2-4.6-1.3-6.9z" fill="currentColor" fillOpacity="0.2" />
      <path d="M38.5 17.5h6.5" strokeWidth={1.4} />
      <circle cx="34.5" cy="16.5" r="1.6" fill="currentColor" stroke="none" />
      <path d="M33 11c-1.5-3.5-3.5-5-7-5.5" />
    </svg>
  );
}

/** Ned: cabeza ancha y cuerpo de pera, para que no sea una bola. */
function NedGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M17 12c-1.5-4-1.5-7.5-4-10.5M11 3L6.5 1.5M13.5 7.5L9 7" />
      <path d="M31 12c1.5-4 1.5-7.5 4-10.5M37 3l4.5-1.5M34.5 7.5L39 7" />
      <path d="M13 19.5c-3-2.2-4.5-6.2-3-8.7 2.3 1.1 4.4 4.2 5 7.2z" fill="currentColor" fillOpacity="0.22" />
      <path d="M35 19.5c3-2.2 4.5-6.2 3-8.7-2.3 1.1-4.4 4.2-5 7.2z" fill="currentColor" fillOpacity="0.22" />
      <path d="M24 10c-7 0-11.5 4.3-11.5 10.2 0 5.5 5 9.6 11.5 9.6s11.5-4.1 11.5-9.6C35.5 14.3 31 10 24 10z" fill="currentColor" fillOpacity="0.16" />
      <circle cx="19.5" cy="20" r="2.6" fill="currentColor" stroke="none" />
      <circle cx="28.5" cy="20" r="2.6" fill="currentColor" stroke="none" />
      <path d="M21.5 25.5q2.5 2.2 5 0" />
      <path d="M19.5 29c-5 2-8.5 5.6-8.5 9.6 0 3.2 5.8 5.2 13 5.2s13-2 13-5.2c0-4-3.5-7.6-8.5-9.6z" fill="currentColor" fillOpacity="0.22" />
      <path d="M11.5 36l-3.5 2.5M36.5 36l3.5 2.5" />
    </svg>
  );
}

/**
 * Buitre: el unico que cruza la muralla en los dos sentidos. Las alas van
 * anchas y casi horizontales, como las de un ave planeando: levantadas y
 * puntiagudas se leian como las de una mariposa.
 */
function VultureGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 48 48" fill="none" aria-hidden className={className}>
      <g stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" fillOpacity="0.5">
        <path d="M19 33l-6 12.5 11-4z" fill="var(--organ-green)" />
        <path d="M29 33l6 12.5-11-4z" fill="var(--organ-yellow)" />
        <path d="M19.5 18C14 14.5 8 13 2.5 13.5c-1 3.8.6 7.4 3.8 10 3.6 3 8.4 4.4 13.7 4.6z" fill="var(--organ-red)" />
        <path d="M28.5 18C34 14.5 40 13 45.5 13.5c1 3.8-.6 7.4-3.8 10-3.6 3-8.4 4.4-13.7 4.6z" fill="var(--organ-blue)" />
        <path d="M6 15.5l2.5 7M10.5 14.5l2 7.5M15 14.5l1.5 7M42 15.5l-2.5 7M37.5 14.5l-2 7.5M33 14.5l-1.5 7" strokeWidth={1.4} />
        <path d="M24 13c-3.6 0-5.4 3-5.4 7.4v11.4c0 4.2 2.2 7.6 5.4 8.8 3.2-1.2 5.4-4.6 5.4-8.8V20.4c0-4.4-1.8-7.4-5.4-7.4z" />
        <circle cx="24" cy="8" r="3.6" />
        <path d="M27.4 7c2.6.5 3.5 2.1 2.5 3.7-1-1-2.1-1.4-3.2-1.3" />
      </g>
    </svg>
  );
}

/** Obispo: la capucha, el hueco sin cara y las manos manchadas. */
function BishopGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M24 6c-5.5 0-9.5 4.5-9.5 10.5L11 42h26l-3.5-25.5C33.5 10.5 29.5 6 24 6z" fill="currentColor" fillOpacity="0.18" />
      <path d="M19 18c0-3.7 2.2-6.6 5-6.6s5 2.9 5 6.6c0 3-2.2 5.7-5 6.5-2.8-.8-5-3.5-5-6.5z" fill="currentColor" fillOpacity="0.45" />
      <path d="M14.5 26L9.5 35M33.5 26l5 9" />
      <circle cx="8.6" cy="38" r="2.9" fill="currentColor" stroke="none" />
      <circle cx="39.4" cy="38" r="2.9" fill="currentColor" stroke="none" />
    </svg>
  );
}

/** Petalo cayendo: punta en (x, y), girado `rot` grados y escalado `s`. */
function Petal({ x, y, rot, s = 1 }: { x: number; y: number; rot: number; s?: number }) {
  return (
    <path
      d={`M${x} ${y}c${3.4 * s} ${3.2 * s} ${3.4 * s} ${8 * s} 0 ${11.2 * s}c-${3.4 * s}-${3.2 * s}-${3.4 * s}-${8 * s} 0-${11.2 * s}z`}
      transform={`rotate(${rot} ${x} ${y})`}
      fill="currentColor"
      fillOpacity="0.28"
    />
  );
}

function PetalsGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <Petal x={16} y={4} rot={-18} s={1.05} />
      <Petal x={33} y={13} rot={48} s={0.85} />
      <Petal x={12} y={22} rot={-58} s={0.8} />
      <Petal x={27} y={29} rot={14} s={1.1} />
      <path d="M38 27q4 4 2 9M8 38q3 3 7 2" strokeWidth={1.3} strokeOpacity="0.5" />
    </svg>
  );
}

/** Cambio de guardia: dos relevandose, uno por otro. */
function BarterGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <circle cx="13" cy="21" r="5.5" fill="currentColor" fillOpacity="0.18" />
      <path d="M4 38v-4a9 9 0 0 1 18 0v4z" fill="currentColor" fillOpacity="0.16" />
      <circle cx="35" cy="21" r="5.5" fill="currentColor" fillOpacity="0.18" />
      <path d="M26 38v-4a9 9 0 0 1 18 0v4z" fill="currentColor" fillOpacity="0.16" />
      <path d="M13 12c6-5.5 16-5.5 22 0M35 12l-.4-4.6M35 12l-4.6-.4" />
      <path d="M35 43c-6 3.5-16 3.5-22 0M13 43l.4 4.2M13 43l4.6.4" />
    </svg>
  );
}

function RaidGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M6 11h24v31H6z" fill="currentColor" fillOpacity="0.14" />
      <path d="M6 21h24M6 31h24M15 11v10M23 21v10M15 31v11" strokeWidth={1.3} strokeOpacity="0.5" />
      <path d="M12 42v-8a6 6 0 0 1 12 0v8z" fill="currentColor" fillOpacity="0.42" />
      <path d="M32 28h11" />
      <path d="M38 23l5.5 5-5.5 5" />
    </svg>
  );
}

/** Un obispo pequeno para las filas de Los nueve: cabeza encapuchada y manto. */
function Friar({ cx, y, s }: { cx: number; y: number; s: number }) {
  return (
    <g>
      <path d={`M${cx - 3.6 * s} ${y + 2 * s}h${7.2 * s}l${6.4 * s} ${19 * s}h${-20 * s}z`} fill="currentColor" fillOpacity="0.18" />
      <circle cx={cx} cy={y} r={4 * s} fill="currentColor" fillOpacity="0.32" />
    </g>
  );
}

function NinersGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <Friar cx={10} y={18} s={0.85} />
      <Friar cx={38} y={18} s={0.85} />
      <Friar cx={24} y={11} s={1.05} />
      <path d="M6 39l-3.5 5M6 44H2.5M42 39l3.5 5M42 44h3.5M24 37v6M21 42l3 3.5 3-3.5" />
    </svg>
  );
}

function AssemblageGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M15 40V24a9 9 0 0 1 18 0v16" fill="currentColor" fillOpacity="0.16" />
      <path d="M24 6v6M11 11l3.5 4.5M37 11l-3.5 4.5M5 22h5M38 22h5" />
      <path d="M7 40h34" />
      <circle cx="12" cy="36" r="3" fill="currentColor" fillOpacity="0.3" />
      <circle cx="36" cy="36" r="3" fill="currentColor" fillOpacity="0.3" />
    </svg>
  );
}

function SeizingGlyph({ className }: GlyphProps) {
  return (
    <svg {...CARD} className={className}>
      <path d="M9 9c-1-4-3-5.5-3-8.5M6 2.5L2.5 1M7.5 5.5L4 5M17 9c1-4 3-5.5 3-8.5M20 2.5l3.5-1.5M18.5 5.5L22 5" />
      <circle cx="13" cy="15" r="6" fill="currentColor" fillOpacity="0.18" />
      <path d="M5 29v-3a8 8 0 0 1 16 0v3z" fill="currentColor" fillOpacity="0.16" />
      <circle cx="35" cy="30" r="6" fill="currentColor" fillOpacity="0.42" />
      <path d="M27 44v-3a8 8 0 0 1 16 0v3z" fill="currentColor" fillOpacity="0.4" />
      <path d="M23 15c6.5 1 10.5 4.5 11.5 10M34.5 25.5l-4.6-2M34.5 25.5l1-4.6" />
      <path d="M25 30c-6.5-1-10.5-4.5-11.5-10M13.5 19.5l4.6 2M13.5 19.5l-1 4.6" />
    </svg>
  );
}

/* Fondo: la ciudad de cemento y lo que hay al otro lado del muro, a linea. */

function TowerGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M10 29V9l6-5 6 5v20z" />
      <path {...LINE} d="M15 13h2v6h-2z" />
      <path {...LINE} d="M6 29h20" />
    </svg>
  );
}

function JumpsuitGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M11 6h10l5 3 1.5 6-3.5 1-1.5-3.5V19l.5 8h-4L17 18l-1.5 9h-4l.5-8v-6.5L10.5 16 7 15l1.5-6z" />
      <path {...LINE} d="M13 6l3 2.5L19 6" />
      <path {...LINE} d="M11 18h10" />
    </svg>
  );
}

function NeonGraveGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M11 27V17a5 5 0 0 1 10 0v10" />
      <path {...LINE} d="M6 27h20" />
      <path {...LINE} d="M6 12l2.5 2M26 12l-2.5 2M16 6v3" />
    </svg>
  );
}

function RidgeGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M2 25l8-11 5 6 4-5 11 10z" />
      <path {...LINE} d="M9 14V9M7 11l2-2 2 2M7 8l2-2 2 2" />
    </svg>
  );
}

function WallGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M3 11h26v16H3z" />
      <path {...LINE} d="M3 16.3h26M3 21.6h26M11 11v5.3M21 11v5.3M7 16.3v5.3M16 16.3v5.3M25 16.3v5.3M11 21.6V27M21 21.6V27" />
    </svg>
  );
}

function BonfireGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M16 6c4 4 6 7 6 9.5a6 6 0 0 1-12 0C10 13 12 10 16 6z" />
      <path {...LINE} d="M5 26l12-5M27 26l-12-5M8 25l16-3" />
    </svg>
  );
}

function CompassGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <circle {...LINE} cx="16" cy="16" r="10" />
      <path {...LINE} d="M11 21l4-9 6 3z" />
      <path {...LINE} d="M16 3v3M16 26v3M3 16h3M26 16h3" />
    </svg>
  );
}

function AntlersGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M14 26c-1.5-7-4-10-4-16M10 6L5 4M11 11L6 10.5M12 16L8 16.5" />
      <path {...LINE} d="M18 26c1.5-7 4-10 4-16M22 6l5-2M21 11l5-.5M20 16l4 .5" />
    </svg>
  );
}

function DoorGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <path {...LINE} d="M5 28V7h22v21z" />
      <path {...LINE} d="M11 28V17a5 5 0 0 1 10 0v11" />
      <circle {...LINE} cx="19" cy="22" r="1" />
    </svg>
  );
}

function LetterGlyph({ className }: GlyphProps) {
  return (
    <svg viewBox="0 0 32 32" className={className} aria-hidden>
      <rect {...LINE} x="4" y="9" width="24" height="15" rx="1.5" />
      <path {...LINE} d="M4 10.5l12 8 12-8" />
      <path {...LINE} d="M4 23l8-6M28 23l-8-6" />
    </svg>
  );
}

/** Cenefa: la muralla circular con sus nueve torres detras. */
function SkylineGlyph({ className }: GlyphProps) {
  const towers = [4, 11, 6, 14, 8, 15, 7, 12, 5];
  return (
    <svg viewBox="0 0 64 24" className={className} aria-hidden>
      {towers.map((h, i) => {
        const x = 4 + i * 7;
        return <path key={x} {...LINE} d={`M${x} 16V${16 - h}h4v${h}`} />;
      })}
      <path {...LINE} d="M1 22v-6h62v6" />
      <path {...LINE} d="M1 19h62" />
      <path {...LINE} d="M27 22v-4h4v4" />
    </svg>
  );
}

export const demaArt: PackArt = {
  organs: { red: ClancyGlyph, blue: NedGlyph, green: TrashGlyph, yellow: TorchbearerGlyph, wild: VultureGlyph },
  virus: BishopGlyph,
  medicine: PetalsGlyph,
  treatments: {
    swap: BarterGlyph,
    steal: RaidGlyph,
    spread: NinersGlyph,
    quarantine: AssemblageGlyph,
    malpractice: SeizingGlyph,
  },
  backdrop: {
    items: [
      TowerGlyph,
      JumpsuitGlyph,
      NeonGraveGlyph,
      RidgeGlyph,
      WallGlyph,
      BonfireGlyph,
      CompassGlyph,
      AntlersGlyph,
      DoorGlyph,
      LetterGlyph,
    ],
    band: SkylineGlyph,
  },
};
